module.exports = __webpack_public_path__ + "static/img/chery_3@2x.88d206c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/chery_3@2x.png
// module id = c3i4
// module chunks = 0